export const SCHEDULE_COLORS = {
  open: '#2563eb',
  inProgress: '#d97706',
  pending: '#64748b',
  completed: '#16a34a',
  shipped: '#2e7d32',
  usingDefaults: '#78909c',
  scheduleOverdue: '#ea580c',
  pastDue: '#dc2626',
  dueDateLine: '#f97316',
};

export const GANTT_BAR_ORANGE = SCHEDULE_COLORS.scheduleOverdue;
export const GANTT_BAR_RED = SCHEDULE_COLORS.pastDue;

export const SCHEDULE_LEGEND_ITEMS = {
  calendar: [
    { color: SCHEDULE_COLORS.open, label: 'Active order' },
    { color: SCHEDULE_COLORS.inProgress, label: 'In progress' },
    { color: SCHEDULE_COLORS.usingDefaults, label: 'No hours estimate or unsaved schedule' },
    { color: SCHEDULE_COLORS.shipped, label: 'Shipped' },
    { color: SCHEDULE_COLORS.scheduleOverdue, label: 'Work schedule complete, not shipped' },
    { color: SCHEDULE_COLORS.pastDue, label: 'Past due, not shipped' },
    { color: SCHEDULE_COLORS.dueDateLine, label: 'Order due date' },
  ],
  gantt: [
    { color: SCHEDULE_COLORS.open, label: 'Planned schedule' },
    { color: SCHEDULE_COLORS.inProgress, label: 'In progress' },
    { color: SCHEDULE_COLORS.usingDefaults, label: 'No hours estimate or unsaved schedule' },
    { color: SCHEDULE_COLORS.scheduleOverdue, label: 'Work schedule complete, not shipped' },
    { color: SCHEDULE_COLORS.pastDue, label: 'Past due, not shipped' },
    { color: SCHEDULE_COLORS.dueDateLine, label: 'Order due date' },
  ],
};
